import itemTypes from './itemTypes'

const fieldCondition = (items, fieldId) => {
  return items.find(({ id }) => id === fieldId)
}

const findSelectedOption = (field) => {
  return field.meta.options.find(({ id }) => id === field.value)
}

const itemConditionCheck = (items, conditions) => {
  let con = conditions.filter((condition) => {
    const field = items.find(({ id }) => id === Number(condition.field_id))

    if (field instanceof Object) {
      let fieldValue = field.value

      if (fieldValue instanceof Object && fieldValue.hasOwnProperty('optionIds')) {
        fieldValue = fieldValue.optionIds
      }
      if (!Array.isArray(fieldValue)) {
        fieldValue = [fieldValue]
      }
      return fieldValue.includes(condition.value)
    }
  })
  return con.length > 0
}

const optionConditionCheck = (items, options) => {
  return options.map(option => {
    // Reset show status
    option.show = true

    if (!!option.conditions && option.conditions.length > 0) {
      option.show = option.conditions.filter(condition => {
        return condition !== undefined
      }).every((condition) => {
        let itemOptionConditionField = fieldCondition(items, condition.field_id)

        if (!itemOptionConditionField) {
          return
        }

        let selectedOption = findSelectedOption(itemOptionConditionField)

        if (!selectedOption) {
          return
        }

        return (selectedOption.id === condition.value)
      })
    }

    return option
  })
}

export const itemConditionHelper = (items, allItems) => {
  return items.map(item => {
    item.show = true

    if (item.meta.hasOwnProperty('conditions') && item.meta.conditions.length > 0) {
      item.show = itemConditionCheck(allItems, item.meta.conditions)
    }

    if (item.meta.hasOwnProperty('options')) {
      item.meta.options = optionConditionCheck(allItems, item.meta.options)
    }

    return item
  })
}

export const dateValueFormat = (value) => {
  if (!value) {
    return null
  }

  let date = new Date(value)

  let pad = '00'
  let day = date.getDate()
  let month = (date.getMonth() + 1)

  day = (pad + day).slice(-pad.length)
  month = (pad + month).slice(-pad.length)

  return day + '/' + month + '/' + date.getFullYear()
}

export const checkBoxValueFormat = (item) => {
  if (item.meta.allowOtherChoice === true && item.value !== null && item.value.optionIds !== null) {
    item.value.optionIds = item.value.optionIds = item.value.optionIds.filter((option) => {
      return option !== `option-${item.id}-other`
    })
  }

  return item.value
}

export const multipleChoiceValueFormat = (item) => {
  if (item.meta.allowOtherChoice === true) {
    if (item.value === `option-${item.id}-other` && item.otherValue !== null) {
      item.value = item.otherValue
    }
  }
  return item.value
}

export const formatItemsForPost = (items) => {
  return items
    .filter(item => item.show)
    .map(item => {
    // Set otherValue as item value when submitting to the API
      if (item.type === itemTypes.MULTIPLE_CHOICE && item.meta.allowOtherChoice === true) {
        item.value = multipleChoiceValueFormat(item)
      }

      if (item.type === itemTypes.CHECKBOXES) {
        item.value = checkBoxValueFormat(item)
      }

      if (item.type === itemTypes.DATE) {
        item.value = dateValueFormat(item.value)
      }

      return item
    })
}
